export default __webpack_public_path__ + "static/left-30f28dbf740706e23d9cf5c93cceb2f7.png";